/**
 * DateRangePicker for Meta ad browse filtering
 * Uses native date inputs for simplicity (Torvalds principle)
 */

import { Calendar } from 'lucide-react';

import type { MetaDateRange } from '@/types/meta';

interface DateRangePickerProps {
  value: MetaDateRange;
  onChange: (range: MetaDateRange) => void;
  disabled?: boolean;
}

export function DateRangePicker({ value, onChange, disabled }: DateRangePickerProps) {
  const handleSinceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...value, since: e.target.value });
  };

  const handleUntilChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...value, until: e.target.value });
  };

  return (
    <div className="flex items-center gap-3">
      <Calendar className="h-4 w-4 text-muted" />
      <div className="flex items-center gap-2">
        <input
          type="date"
          value={value.since}
          onChange={handleSinceChange}
          disabled={disabled}
          className="px-2 py-1 text-sm border border-border-subtle rounded-md bg-surface focus:outline-none focus:ring-2 focus:ring-brand/20 disabled:opacity-50"
          aria-label="Start date"
        />
        <span className="text-sm text-muted">to</span>
        <input
          type="date"
          value={value.until}
          onChange={handleUntilChange}
          disabled={disabled}
          className="px-2 py-1 text-sm border border-border-subtle rounded-md bg-surface focus:outline-none focus:ring-2 focus:ring-brand/20 disabled:opacity-50"
          aria-label="End date"
        />
      </div>
    </div>
  );
}
